import { newId, now } from '../model/ids';
import type { DeviceInfo } from '../model/types';
import type { Repo } from './repo';

const DEVICE_KEY = 'device';

/**
 * This install's device record. A new record (new id) is created whenever the
 * user agent, DPR, screen or touch points change, so each stroke's deviceId
 * always points at the exact environment it was captured in.
 */
export async function getDevice(repo: Repo): Promise<DeviceInfo> {
  const stored = await repo.getSetting<DeviceInfo>(DEVICE_KEY);
  const fresh = collectDeviceInfo(newId());
  if (stored && sameHardware(stored, fresh)) return stored;
  await repo.setSetting(DEVICE_KEY, fresh);
  return fresh;
}

function sameHardware(a: DeviceInfo, b: DeviceInfo): boolean {
  // Width/height swap on rotation; that is not a different device.
  const dims = (d: DeviceInfo) => [d.screen.width, d.screen.height].sort((x, y) => x - y).join('x');
  return a.userAgent === b.userAgent && a.devicePixelRatio === b.devicePixelRatio
    && dims(a) === dims(b) && a.maxTouchPoints === b.maxTouchPoints;
}

export function collectDeviceInfo(id: string): DeviceInfo {
  return {
    id,
    userAgent: navigator.userAgent,
    devicePixelRatio: window.devicePixelRatio,
    screen: {
      width: screen.width,
      height: screen.height,
      availWidth: screen.availWidth,
      availHeight: screen.availHeight,
    },
    maxTouchPoints: navigator.maxTouchPoints,
    recordedAt: now(),
  };
}
